/* eslint-disable @typescript-eslint/no-explicit-any */
import type intlTelInput from 'intl-tel-input';

export function ensureDialCodePrefill(
  input: HTMLInputElement | null | undefined,
  plugin: intlTelInput.Plugin | undefined
): void {
  if (!input || !plugin) return;

  const dialCode = (plugin as any)?.getSelectedCountryData?.()?.dialCode;
  if (!dialCode) return;

  if (input.value.trim()) return;

  input.value = dialCode.startsWith('+') ? dialCode : `+${dialCode}`;
}

export function attachDialCodePrefill(
  input: HTMLInputElement | null | undefined,
  plugin: intlTelInput.Plugin | undefined
): void {
  if (!input) return;
  const apply = (): void => ensureDialCodePrefill(input, plugin);
  apply();
  input.addEventListener('focus', apply);
  input.addEventListener('blur', apply);
}
